import React, { useEffect } from "react";
import { observer } from "mobx-react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// custom components
import ScheduleList from "./ScheduleList";
import AgeCheckBoxes from "./AgeCheckBoxes";

import productStyle from "assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.js";
import CustomInput from "../../../components/CustomInput/CustomInput";
import Typography from "@material-ui/core/Typography";
import { decodeFilter, encodeFilter } from "../../../utils/Utils";
import { useHistory } from "react-router-dom";
import TypeCheckBoxes from "./TypeCheckboxes";

const styles = () => ({
	...productStyle,
	filterSubHeader: {
		color: "black",
		fontWeight: "400",
	},
	subHeaderWrapper: {
		borderBottom: "solid",
		color: "lightgrey",
		borderBottomWidth: 1,
	},
});

const useStyles = makeStyles(styles);

const Filter = observer((props) => {
	const filter = props.filter;
	const history = useHistory();

	useEffect(() => {
		const filterParams = decodeFilter(window.location.href);
		props.setFilter({
			...filterParams,
		});
	}, []);

	const setFilter = (filter) => {
		props.setFilter({
			...filter,
		});
		const urlEncodedFilter = encodeFilter(filter);
		history.replace(`/activities/filter&${urlEncodedFilter}`);
	};

	const toggleOfferingType = (offeringType) => {
		const currentOfferingTypes = [...filter.offeringTypes];
		const index = currentOfferingTypes.indexOf(offeringType);

		if (offeringType === "EVERYTHING") {
			setFilter({
				...filter,
				offeringTypes: [],
			});
		} else if (index === -1) {
			setFilter({
				...filter,
				offeringTypes: [...currentOfferingTypes, offeringType],
			});
		} else {
			currentOfferingTypes.splice(index, 1);
			setFilter({
				...filter,
				offeringTypes: currentOfferingTypes,
			});
		}
	};

	const toggleAgeGroup = (ageGroup) => {
		const currentAgeGroups = [...filter.ageGroups];
		const index = currentAgeGroups.indexOf(ageGroup);

		if (ageGroup === "EVERYONE") {
			setFilter({
				...filter,
				ageGroups: [],
			});
		} else if (index === -1) {
			setFilter({
				...filter,
				ageGroups: [...currentAgeGroups, ageGroup],
			});
		} else {
			currentAgeGroups.splice(index, 1);
			setFilter({
				...filter,
				ageGroups: currentAgeGroups,
			});
		}
	};

	const setSchedule = (schedule) => {
		const schedules = filter.schedules;
		const scheduleIndex = schedules.findIndex((e) => e.day === schedule.day);

		if (scheduleIndex !== -1) {
			const newSchedules = [...schedules];
			newSchedules[scheduleIndex] = schedule;

			setFilter({
				...filter,
				schedules: newSchedules,
			});
		} else {
			const newSchedules = [...schedules, schedule];

			setFilter({
				...filter,
				schedules: newSchedules,
			});
		}
	};

	const removeSchedule = (schedule) => {
		const schedules = filter.schedules;
		const scheduleIndex = schedules.findIndex((e) => e.day === schedule.day);

		if (scheduleIndex !== -1) {
			const newSchedules = [...schedules];
			newSchedules.splice(scheduleIndex, 1);

			setFilter({
				...filter,
				schedules: newSchedules,
			});
		}
	};

	const setSearchText = (searchText) => {
		setFilter({
			...filter,
			searchText,
		});
	};

	const classes = useStyles();

	return (
		<div className={classes.textLeft}>
			<CustomInput
				labelText="Suche"
				id="float"
				formControlProps={{
					fullWidth: true,
				}}
				inputProps={{
					value: filter.searchText,
					onChange: (event) => {
						setSearchText(event.target.value);
					},
				}}
			/>
			<div className={classes.subHeaderWrapper}>
				<Typography variant="subtitle1" className={classes.filterSubHeader}>
					Angebotstypen
				</Typography>
			</div>
			<TypeCheckBoxes
				offeringTypes={filter.offeringTypes}
				toggleOfferingType={toggleOfferingType}
			/>
			<div className={classes.subHeaderWrapper}>
				<Typography variant="subtitle1" className={classes.filterSubHeader}>
					Alter & Person
				</Typography>
			</div>
			<AgeCheckBoxes
				ageGroups={filter.ageGroups}
				toggleAgeGroup={toggleAgeGroup}
			/>

			<div className={classes.subHeaderWrapper}>
				<Typography variant="subtitle1" className={classes.filterSubHeader}>
					Trainingstage
				</Typography>
			</div>
			<div style={{ marginTop: 10 }}>
				<ScheduleList
					schedules={filter.schedules}
					onSetSchedule={setSchedule}
					onRemoveSchedule={removeSchedule}
				/>
			</div>
		</div>
	);
});

export default Filter;
